import React from 'react'
import { BENEFITS_IMAGE } from '../helpers/constants'
import Button from './MainButton'

const Component = (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <div data-type='block-wrapper'>
      <div data-type='block' data-style='benefits'>
        <div data-type='block-text'>
          <p data-type='block-title'>Fair, Transparent, and Easy</p>
          <p data-type='block-sub-text'>
            Choose how and when you get paid. We offer secure payments by check, wire transfer or
            PayPal. Our support specialists ensure our artists and collectors are financially
            protected on every sale.
          </p>
          <ul data-type='block-list'>
            <li>Free to create an account</li>
            <li>We handle shipping - you only pay for packaging</li>
            <li>No fees</li>
            <li>Receive 60% on every artwork sold</li>
            <li>Non-exclusive policy</li>
            <li>Secure online payments</li>
          </ul>
        </div>
        <div data-type='block-image'>
          <picture data-type='image'>
            <img
              width='502'
              height='501'
              itemProp='image'
              src={BENEFITS_IMAGE}
              alt='hero'
              role='presentation'
              data-type='image'
            />
          </picture>
        </div>
      </div>
      <Button dataStyle='benefits-button' modalName='from-benefits' />
      <hr />
    </div>
  )
}

export default Component